import { Navigate, useLocation, useParams } from 'react-router-dom';
import { buildResetPasswordTokenPath, resetPasswordPath } from 'common/config/urls';

const ResetPasswordLegacyRedirect = () => {
  const location = useLocation();
  const { token, uid } = useParams<{ token: string; uid: string }>();

  if (!uid || !token) {
    return <Navigate replace to={resetPasswordPath} />;
  }

  return <Navigate replace to={`${buildResetPasswordTokenPath(uid, token)}${location.search}`} />;
};

export default ResetPasswordLegacyRedirect;
